export default "__VITE_ASSET__ITiyG7bf__"